<script>
// import Constants from '../constants';

export default {
  name: 'vueBandCamp',
  components: {
  },
  props: {
    embeddedUrl: {
      type: String,
      required: true,
    },
    hrefUrl: {
      type: String,
      default: true,
    },
    albumTitle: {
      type: String,
      default: true,
    }
  },
  data() {
    return {
      ready: false,
    };
  },
  beforeDestroy () { // https://qiita.com/kai-ono/items/48cadf3d8ed3ae9effdd
    if (window.instgrm) {
      delete window.instgrm;
    }
  },
  created() {
    setTimeout(()=> {
      this.ready = true;
    }, 1);
  },
};
</script>

<template>
  <div class="bandcamp-container" v-if="ready">
    <iframe
      style="border: 0; width: 100%; height: 100%;"
      :src="embeddedUrl"
      seamless
    >
      <a :href="hrefUrl" target="_blank">
        {{albumTitle}} by {{$t('message.bandName')}}
      </a>
    </iframe>
  </div>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  .bandcamp-container {
    position: relative;
    width: 100%;
    height: 100%;
  }
</style>
